import React from 'react';

export const Circles = React.memo((props: React.SVGProps<SVGSVGElement>) => {
  const size = props.width === 24 ? 36 : 24;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentcolor"
      {...props}
      width={size}
      height={size}
    >
      <path
        d="M21.586 12.1C21.586 6.84812 17.3519 2.61397 12.1 2.61397C6.84812 2.61397 2.61397 6.84812 2.61397 12.1C2.61397 17.3519 6.84812 21.586 12.1 21.586C17.3519 21.586 21.586 17.3519 21.586 12.1ZM2.5 12.1C2.5 6.80629 6.80629 2.5 12.1 2.5C17.3937 2.5 21.7 6.80629 21.7 12.1C21.7 17.3937 17.3937 21.7 12.1 21.7C6.80629 21.7 2.5 17.3937 2.5 12.1Z"
        fill="#6DD1F4"
      />
      <path
        d="M14.625 14.8479C15.8875 13.6596 17.15 12.1001 17.15 10.6891C17.15 9.27803 16.036 8.16406 14.625 8.16406C13.4368 8.16406 12.3971 8.98097 12.1 10.1692C11.803 9.05524 10.8375 8.16406 9.57502 8.16406C8.16399 8.16406 7.05002 9.27803 7.05002 10.6891C7.05002 13.6596 12.1 16.9273 12.1 16.9273"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default Circles;
